module.exports = __webpack_public_path__ + "static/media/arrow-right.1eccc6dc.svg";